import {concatUrl} from './base'
import {appRequest} from './request'
import {decode} from 'js-base64';
import {encrypt, sessionCache} from '@gyasset/shared/utils';
import constants from './constants'
import store from '@/store'

const {FundInformationFileTypePdf, FundInformationFileTypeAudio, FundInformationFileTypeVideo} = constants

const userStatusUrl = concatUrl('/user/status')

/**
 * @returns {string} 枚举值，从forbidden, assets, invest_identity, info, complete中取值
 */
export async function userStatus() {
  const status = await appRequest(userStatusUrl, {
    method: 'GET'
  })
  return status
}

export async function userValid () {
    const response = await appRequest(concatUrl('/user/isValid'), {
        method: 'GET'
    })
    return response.data
}

export async function tabs () {
    const response = await appRequest(concatUrl('/user/tabs'), {
        method: 'GET'
    })
    return response.data
}

const riskInfoUrl = concatUrl('/user/riskinfo')
/**
 * 查询风险测评信息
 * @returns {grades: 1, level: 1, need_level: 3, allowed: false}
 */
export async function riskInfo () {
  const riskInfo = await appRequest(riskInfoUrl, {
    method: 'GET'
  })
  return riskInfo
}

/**
 * 查询当前登录客户是否需要特定对象确认（合格投资者确认）
 * @param fundId 产品id，可空；关注基金点击时携带，首页查询不传
 * @returns {Promise<{need_confirm: boolean, reason: string, last_confirm_date: string|null}>}
 */
export async function specialConfirmStatus (fundId) {
  const url = fundId
    ? `${concatUrl('/potentialConfirm/specialConfirmStatus')}?fundId=${fundId}`
    : concatUrl('/potentialConfirm/specialConfirmStatus')
  const res = await appRequest(url, {
    method: 'GET'
  })
  return res
}

/**
 * 提交特定对象确认
 */
export async function submitSpecialConfirm () {
  const res = await appRequest(concatUrl('/potentialConfirm/submitSpecialConfirm'), {
    method: 'POST'
  })
  return res
}

const userInfoUrl = concatUrl('/user/info')
export async function userInfo () {
  const info = await appRequest(userInfoUrl, {
    method: 'GET'
  })
  if (info.mobile) {
    info.mobile = decode(info.mobile)
  }
  if (info.customer_email) {
    info.customer_email = decode(info.customer_email)
  }
  if (info.id_number) {
    info.id_number = decode(info.id_number)
  }
  let isIdCardExpired = false;
  if (info.id_card_expired) {
    isIdCardExpired = true;
  }
  store.commit('setIdCardExpired', isIdCardExpired);
  return info
}

/**
 * 是否为公众号中登录
 *
 */
export async function isOfficialAccounts (logout) {
  if (logout === undefined || logout == null) {
    logout = ''
  }
  const url = concatUrl('/login/isOfficialAccounts?logout=' + logout)
  const result = await appRequest(url, {
    method: 'GET',
    timeout: 15000
  })
  return result
}

/**
 *
 * @param {object} options 和userInfo方法返回的结构相同的对象
 */
export async function saveUserInfo (options) {
  const body = JSON.stringify(options)
  const result = appRequest(userInfoUrl, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

export async function confirmBasicInfo (options) {
    const body = JSON.stringify(options)
    const result = appRequest(userInfoUrl+'/confirmBasicInfo', {
        method: 'POST',
        body,
        headers: { 'Content-Type': 'application/json' }
    })
    return result
}



const comfirmProfessionalInvestorUrl = concatUrl('/user/identity/professional')
/**
 *
 * @param {string} question1 第一题答案
 * @param {string} question2 第二提答案
 * @returns {boolean} 是否是专业投资人
 */
export async function confirmProfessionalInvestor (question1, question2) {
  const body = new FormData()
  body.append('question1', question1)
  body.append('question2', question2)
  const result = await appRequest(comfirmProfessionalInvestorUrl, {
    method: 'POST',
    body
  })
  return result
}

const confirmNormalInvestorUrl = concatUrl('/user/identity/normal')
/**
 *
 * @param {*} options {group1: [0, 1], group2: [1, 0, 2, ...]} 两组答题的答案序号
 */
export async function confirmNormalInvestor (options) {
  const body = JSON.stringify(options)
  const result = appRequest(confirmNormalInvestorUrl, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

const comfirmNormalInvestorUrl = concatUrl('/user/identity/normal')
export async function comfirmNormalInvestor (options) {
  const body = JSON.stringify(options)
  const result = appRequest(comfirmNormalInvestorUrl, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

const myAppointmentsUrl = concatUrl('/user/appoints')
export async function myAppointments () {
  const url = `${myAppointmentsUrl}`
  const result = await appRequest(url, {
    method: 'GET'
  })
  return result
}

/**
 *
 * @param {string} appointId
 * @returns {object}
 * {fund_name, accumulated_income_rage: '82%', net_worth: '1.82', subscript_point: 1000000.0, add_subscript_limit: '最少一万元'，
 * publish_date: '2018-05-12', trade_start_date: '2018-05-12', deposit_bank: '中信证券', investment_scope: '投资范围',
 * manage_fee: '0.2%', custody_fee: '0.2%', service_fee: '0.2%', factor: 0.2, evaluate_type: '业绩报酬提取方式',
 * performance_frequency: '月度'
 * }
 */
export async function myAppoint (appointId) {
  const url = concatUrl(`user/appoint/${appointId}`)
  const result = await appRequest(url, {
    method: 'GET'
  })
  return result
}

/**
 *
 * @param {string} appointId
 * @returns {object}
 * {
 *   fund_navs: [{date: 'yyyy-MM-dd', nav: 1.2}]
 *   index_navs: [
 *     {index_type: '000300.SH', index_name: '沪深300', navs: [{date: 'yyyy-MM-dd', nav: 3000.1}],
 *     {index_type: '399006.SZ', index_name: '创业板指', navs: [{date: 'yyyy-MM-dd', nav: 2000.1}]
 *   ]
 * }
 */
export async function myAppointTrend (appointId) {
  const url = concatUrl(`user/appoint/${appointId}/trend`)
  const result = await appRequest(url, {
    method: 'GET'
  })
  return result
}

const myAppliesUrl = concatUrl('/user/applies')

/**
 *
 * @param {object} param0
 * @returns {object}
 * {
 *  apply_id: '',
 *  fund_name: '',
 *  apply_type: '',
 *  apply_message: '',
 * }
 */
export async function myApplies ({ page, size }) {
  const url = `${myAppliesUrl}?page=${page}&size=${size}`
  const result = await appRequest(url, {
    method: 'GET'
  })
  return result
}

const myApplyCountUrl = concatUrl('/user/applyCount')
/**
 *
 * @param {object} param0
 * @returns {object}
 * {
 *  apply_id: '',
 *  fund_name: '',
 *  apply_type: '',
 *  apply_message: '',
 * }
 */
export async function myApplyCount ({ fundId }) {
  const url = fundId ? `${myApplyCountUrl}?fundId=${fundId}` : myApplyCountUrl
  const result = await appRequest(url, {
    method: 'GET'
  })
  return result
}

export async function onPassageApply (page, size) {
  const url = concatUrl(`/user/applies/onPassage?page=${page}&size=${size}`)
  return await appRequest(url, {
    method: 'GET'
  })
}
export async function historyApply (page, size) {
  const url = concatUrl(`/user/applies/history?page=${page}&size=${size}`)
  return await appRequest(url, {
    method: 'GET'
  })
}
/*
 *@returns {object} {fund_name, stage_list: [{value: 0, name: '', status: 'waiting/processing/success/failed', message: ''}] }
 */
export async function myApply (applyId) {
  const url = concatUrl(`/user/apply/${applyId}`)
  const result = await appRequest(url, {
    method: 'GET'
  })
  return result
}

/**
 * 交易信息列表
 * @param page
 * @param size
 * @returns {Promise<*>}
 */
export async function getDealInfoList ({page, size}) {
  const historyInfoUrl = concatUrl(`/user/fund/dealInfo?page=${page}&size=${size}`)
  return appRequest(historyInfoUrl, { method: 'GET' })
}

/**
 * 交易信息详情
 * @param tradeId
 * @returns {Promise<*>}
 */
export async function getHistoryInfo(tradeId) {
  const historyInfoUrl = concatUrl(`/user/fund/historyInfo?tradeId=${tradeId}`)
  return appRequest(historyInfoUrl, { method: 'GET' })
}

//todo 废弃
// export async function redeemHavaCarryOrNot() {
//   const redeemHavaCarryOrNotUrl = concatUrl(`/user/fund/redeemHavaCarryOrNot`)
//   return appRequest(redeemHavaCarryOrNotUrl, { method: 'GET' })
// }

/**
 * personData
 */
export async function setPersonData (obj, code) {
  let {
    education,
    position,
    customerEmail,
    address_in_china,
    country,
    province,
    city,
    county,
    address,
    mobile,
    password,
    newPassword,
    riskRemind,
    agree,
    representEffectiveEndDate,
    representEffectiveType
  } = obj
  education = encodeURI(education)
  position = encodeURI(position)
  address_in_china = encodeURI(address_in_china)
  country = encodeURI(country)
  province = encodeURI(province)
  city = encodeURI(city)
  county = encodeURI(county)
  address = encodeURI(address)
  password = password ? encrypt.md5(password) : undefined
  newPassword = encrypt.md5(newPassword)
  let setPersonDataUrl
  switch (code) {
    case '0':
      setPersonDataUrl = concatUrl(`/user/info/update?education=${education}&position=${position}`)
      break
    case '1':
      setPersonDataUrl = concatUrl(`/user/info/update?customer_email=${customerEmail}&token=${token}`)
      break
    case '2':
      setPersonDataUrl = concatUrl(`/user/info/update?address_in_china=${address_in_china}&country=${country}&province=${province}&city=${city}&county=${county}&address=${address}`)
      break
    case '3':
      setPersonDataUrl = concatUrl(`/user/info/update?mobile=${mobile}`)
      break
    case '4':
      setPersonDataUrl = concatUrl(`/user/info/update?password=${password}&newPassword=${newPassword}`)
      break
    case 'risk_remind':
      setPersonDataUrl = concatUrl(`/user/info/update?risk_remind=${riskRemind}`)
      break
    case 'idNoEndDate':
      setPersonDataUrl = concatUrl(`/user/info/update?representEffectiveEndDate=${representEffectiveEndDate}&representEffectiveType=${representEffectiveType}`)
      break
    default:
      setPersonDataUrl = concatUrl(`/user/info/update?agree=${agree}`)
  }
  console.log(setPersonDataUrl)
  return appRequest(setPersonDataUrl, { method: 'POST' })
}
/**
 * 查询历史公告报告接口 {found_id: string; type: 1 | 2}
 */
export async function fundReport ({fund_id,fundId, type= ['1', '0'] }) {
  const url = concatUrl(`/user/fundReport`)
  const result = await appRequest(url, {
    method: 'POST',
    body: JSON.stringify({fund_id : fund_id || fundId, type}),
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
/**
 * 登陆后查看是否有: 冷静期中收到客户打款记录
 */
export async function unmatched () {
  const unmatched = concatUrl(`/user/apply/unmatched`)
  return appRequest(unmatched, { method: 'GET' })
}
export async function confirmUnmatched (applyId) {
  const unmatched = concatUrl(`/user/apply/unmatched/${applyId}`)
  return appRequest(unmatched, { method: 'POST' })
}

export async function updateConfirmFailToReaded(){
  const url = concatUrl(`/user/applies/readConfirmFailApply`)
  return await appRequest(url, {
    method: 'POST',
  })
}


export async function confirmUnmatchedEdit ({ applyId, ...options }) {
  console.log({ applyId, ...options })
  // /user/appoint/{applyId}/edit
  const url = concatUrl(`/user/appoint/${applyId}/edit`)
  const body = JSON.stringify(options)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
/**
 * 有一笔未处理款项：退回款项
 */
export async function refund (applyId) {
  const refundUrl = concatUrl(`/daily/refund/${applyId}`)
  console.log(refundUrl)
  return appRequest(refundUrl, { method: 'POST' })
}
/**
 * 风险揭示书
 */
export async function cancelRiskRemind () {
  const url = concatUrl(`user/riskRemind`)
  return appRequest(url, { method: 'GET' })
}

/**
 * 是否为公众号中登录
 *
 */
export async function isOfficialAccountsLogout () {
  const url = concatUrl('/login/isOfficialAccounts?logout=true')
  const result = await appRequest(url, {
    method: 'GET',
    timeout: 15000
  })
  return result
}

/**
 * 微信解绑
 */
const wechatUnbundleUrl = concatUrl('/wechatUnbundle')
export async function wechatUnbundle () {
  const info = await appRequest(wechatUnbundleUrl, {
    method: 'GET'
  })
  return info
}
/**
 * 查询注册协议是否更新
 */
const agreementInfoUrl = concatUrl('/notice/findAgreementWhenLogin')
export async function agreementInfo () {
  const info = await appRequest(agreementInfoUrl, {
    method: 'GET'
  })
  return info
}
/**
 * 查询注册协议内容
 */
const agreementsUrl = concatUrl('/notice/findAgreement')
export async function agreement () {
  const info = await appRequest(agreementsUrl, {
    method: 'GET'
  })
  return info
}
const updateUserAgreementUrl = concatUrl('/notice/updateUserNoticeEntity')
export async function updateUserAgreement () {
  const info = await appRequest(updateUserAgreementUrl, {
    method: 'GET'
  })
  return info
}


//有资产无手机号的客户
export async function noMobileHaveAsset (idNo) {
  const noMobileHaveAssetUrl = concatUrl(`/regist/noMobileHaveAsset?idNo=${idNo}`)
  return appRequest(noMobileHaveAssetUrl, {
    method: 'GET'
  })
}

//无资产无手机号的客户
export async function limitCustomer (idNo) {
  const limitCustomerUrl = concatUrl(`/regist/limitCustomer?idNo=${idNo}`)
  return appRequest(limitCustomerUrl, {
    method: 'GET'
  })
}

export async function clientInfoStatus (idNo, customerName, mobile) {
    const noMobileHaveAssetUrl = concatUrl(`/regist/clientInfoStatus?idNo=${idNo}&customerName=${customerName}&mobile=${mobile}`)
    return appRequest(noMobileHaveAssetUrl, {
        method: 'GET'
    })
}

export async function getUnReadTrades () {
  let response = await appRequest(concatUrl(`/user/getUnReadTrades`), {
    method: 'GET'
  })
  if (response) {
    return response.data
  }
  return null
}

export async function getUnReadAddInfo () {
  let response = await appRequest(concatUrl(`/clientAccountChange/queryClientUnreadChange`), {
    method: 'POST'
  })
  if (response) {
    return response.data
  }
  return null
}

/**
 * 固定时点业绩报酬计提提示
 * @returns {Array} data: [{trade_date, fund_ids, trade_ids, title, content}]
 */
export async function getAccrualReminds () {
  // 静默失败：接口异常时返回空数组，避免影响页面其他通知（Promise.all 级联）
  try {
    const response = await appRequest(concatUrl(`/user/accrualReminds`), {
      method: 'POST'
    })
    if (response && response.success) {
      return response.data || []
    }
    return []
  } catch (e) {
    return []
  }
}

/**
 * 业绩报酬计提提示已读
 * @param {object} param {trade_ids: string[], trade_date: string}
 */
export async function readAccrualRemind (param) {
  const response = await appRequest(concatUrl(`/user/readAccrualRemind`), {
    method: 'POST',
    body: JSON.stringify(param),
    headers: { 'Content-Type': 'application/json' }
  })
  return response
}
export async function getUnReadAddDetails (param) {
  let response = await appRequest(concatUrl(`/clientAccountChange/queryClientUnreadChangeDetail`), {
    method: 'POST',
    body: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json"
    }
  })
  if (response) {
    return response.data
  }
  return null
}
/**
 * @param isLamp true表示是跑马灯页面请求  false表示其他页面请求
 * @returns {Promise<*>}
 */
export async function queryConfirmFailRecords (isLamp) {
  return  await appRequest(concatUrl(`/user/applies/confirmFailed?isLamp=${isLamp}`), {
    method: 'GET'
  })
}



export async function clearUnReadTrade() {
  return appRequest(concatUrl(`/user/clearUnReadTrade`), {
    method: 'GET'
  })
}

const updateEmailUrl = concatUrl('/user/updateEmail')

export async function updateEmail(params) {
  let body = new FormData()
  body.append("customerEmail", params.customerEmail)
  body.append("messageCode", params.messageCode)
  body.append("token", params.token)
  return appRequest(updateEmailUrl, {
    method: 'POST',
    body: body
  })
}

/**
 * 修改密码时，对原密码作校验
 */
const passwordCheckUrl = concatUrl('user/passwordCheck')
export async function passwordCheck(password) {
  let body = new FormData()
  password = encrypt.md5(password)
  body.append("password",password)
  return appRequest(passwordCheckUrl,{
    method: 'POST',
    body: body
  })
}

/**
 * 税号校验
 */
const verifyTaxNoUrl = concatUrl('user/verifyTaxNo')
export async function verifyTaxNo(taxCountry,taxNo) {
  let body = new FormData()
  body.append("taxCountry",taxCountry)
  body.append("taxNo",taxNo)
  body.append("customerType","1")//微信端是个人
  return appRequest(verifyTaxNoUrl,{
    method: 'POST',
    body: body
  })
}

//todo 获取产品资讯所有数据 包含 已读 未读 及 咨询 和 公告
export async function getQueryInformationAndNoticeList(fundId='') {
  return await appRequest(concatUrl(`/queryInformationAndNoticeList?fundId=${fundId}`), {
    method: 'GET'
  })
}

//todo 更新公告资讯文件的已读状态
export async function updateReadStatusByFileId({fileId,readType,allRead}) {
  const url = concatUrl(`/user/readByFileId`)
  const body = JSON.stringify({file_id: fileId, read_type: readType})
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}


//清空客户近期的已读计数
export async function updateClientRecentRead({type, fileIds}) {
  const url = concatUrl(`/clearClientRecentReade`)
  const body = JSON.stringify({type: type, file_ids: fileIds})
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

//todo  获取所有资讯文件
export async function getQueryFundInformationFileList(param) {
  const url = concatUrl(`/user/queryFundInformationFileList`)
  const result = await appRequest(url, {
    method: 'POST',
    body: JSON.stringify(param),
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

/**
 *  预览音视频信息
 */
export async function fundInformationFilePlay({fileId}) {
  const url = concatUrl(`/fundInformationFilePlay`)+ (fileId ? ('?fileId='+fileId):'')
  return await appRequest(url, {
    method: 'GET'
  })
}


//TODO 获取图片地址    GET请求
export function getPreviewPictureFile(cosPictureFileId) {
  let url = concatUrl(`/previewPictureFile?cosPictureFileId=${cosPictureFileId}`)
  return url
}
//todo 获取微信服务号推送信息 是否有效 /checkFundInformationFileAuthority?fileId=41702
export async function getCheckFundInformationFileAuthority(fileId) {
  const url = concatUrl(`/checkFundInformationFileAuthority?fileId=${fileId}`)
  return await appRequest(url, {
    method: 'GET'
  })
}
//todo 扫码校验   获取微信服务号推送信息 是否有效 /checkFundInformationFileAuthorityForQrCode?uploadRecordId=41702
export async function getCheckFundInformationFileAuthorityForQrCode(uploadRecordId) {
  const url = concatUrl(`/checkFundInformationFileAuthorityForQrCode?uploadRecordId=${uploadRecordId}`)
  return await appRequest(url, {
    method: 'GET'
  })
}

/**
 * 通过分享出去的id 获取真正的文件id  file_title remark
 * @param uploadRecordId
 * @returns {Promise<*>}
 */
export async function getFundInformationForwardInfo(uploadRecordId) {
  const url = concatUrl(`/getFundInformationForwardInfo?uploadRecordId=${uploadRecordId}`)
  return await appRequest(url, {
    method: 'GET'
  })
}

/**
 * 获取交易类型
 * @returns {Promise<*>}
 */
export async function getTradeTypeOptions() {
  return await appRequest(concatUrl('/user/fund/trade/getTradeType'), { method: 'GET' })
}

/**
 * 校验是否有权限 浏览直销月报文件
 * @param fileId
 * @returns {Promise<*>}
 */
export async function getUserCheckFundReport(fileId) {
  const resData = await appRequest(concatUrl(`/user/checkFundReport?fileId=${fileId}`), {
    method: 'GET'
  })
  if (resData.data) {
    return {
      code: resData.data.code,
      message: resData.data.message,
      data: resData.data
    };
  }
  return resData;
}

/**
 * 返回公众号二维码图片
 * @returns {Promise<*|string>}
 */
export async function getWechatQrcode() {
  const link = await  concatUrl(`/upload/img/wechatQrcode.png`)
  return link
}

/**
 * 产品资讯，会议纪要、音频、视频获取截止时间
 * @param fileId
 * @returns {Promise<*>}
 * //   {
//     "code": 200,
//     "message": "操作成功",
//     "data": {
//       // 是否设置可见时间截点 0：不设置 1： 设置
//       "has_visible_deadline": "1",
//       // 结束
//       "visible_deadline": "2024-06-30",
//       // 开始
//       "publish_date": "2024-05-01"
//     },
//     "success": true
//   }
 */
export async function queryFundInformationFileDeadline(fileId) {
  return await appRequest(concatUrl(`/fundInformationFileDeadline?fileId=${fileId}`), {
    method: 'GET'
  })
}

/**
 * 判断是否已经确认过
 * @param param
 * @returns {Promise<*>}
 */
export async function judgeConfirmRecordExist(param){
  const url = concatUrl(`/potentialConfirm/judgeConfirmRecordExist`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

/**
 * 个人： 合格投资者确认书确认，并添加潜在客户
 * @param param
 * @returns {Promise<*>}
 */
export async function addPotentialClient(param){
  const url = concatUrl(`/potentialConfirm/addPotentialClient`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

/**
 * 获取双录的信息
 * @param param
 * @returns {Promise<*>}
 */
export async function requestDualRecordInfo(param){
  const url = concatUrl(`/econtract/dualRecordInfo`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
/**
 * 重新双录
 * @param param
 * @returns {Promise<*>}
 */
export async function requestReDualRecordInfo(param){
  const url = concatUrl(`/econtract/reDualRecord`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
/**
 * 判断是否需要双录
 * @param param
 * @returns {Promise<*>}
 */
export async function judgeDualRecord(param){
  const url = concatUrl(`/econtract/judgeDualRecord`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
/**
 * 判断是否是本人的订单
 * @param param
 * @returns {Promise<*>}
 */
export async function judgeSelfDualRecord(param){
  const url = concatUrl(`/econtract/judgeSelfDualRecord`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
/**
 * 双录计费开始记录
 * @param param  {
    "client_id": "11991",
    "fund_id": "75ed7383e5c74bdd9213e96ad70fa67a"
}
 * @returns {Promise<*>}
 */
export async function startDualRecordLog(param){
  const url = concatUrl(`/econtract/startDualRecordLog`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
/**
 * 双录计费：结束记录
 * @param param {
    // /startDualRecordLog接口中返回的data中的id
    "id": 3,
    "apply_id": 14138,
    // 1:完成双录，0:未完成
    "finish": 1
}
 * @returns {Promise<*>}
 */
export async function endDualRecordLog(param){
  const url = concatUrl(`/econtract/endDualRecordLog`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

/*
 * 机构： 合格投资者确认书确认，并添加潜在客户
 * @param param
 * @returns {Promise<*>}
 */
export async function addInstitutionPotentialClient(param){
  const url = concatUrl(`/potentialConfirm/addInstitutionPotentialClient`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

export async function updateClientChangeToRead (param) {
  let response = await appRequest(concatUrl(`/clientAccountChange/updateClientChangeToRead`), {
    method: 'POST',
    body: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json"
    }
  })
  if (response) {
    return response.data
  }
  return null
}
/**
 * ---
 * @param param
 * @returns {Promise<*>}
 */
export async function requestPreviewInfo(param){
  const url = concatUrl(`/filePreview/getPreviewInfo`)
  const body = JSON.stringify(param)
  const result = await appRequest(url, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

// 查产品咨询轮播数据
export async function queryCarouselData(){
  const url = concatUrl(`/queryCarouselData`)
  const result = await appRequest(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
//查询最近60的公告、报告、产品资讯
// / queryClientRecentReport
export async function queryClientRecentReport(){
  const url = concatUrl(`/queryClientRecentReport`)
  const result = await appRequest(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
//查询历史交易过的产品
// /queryHistoryHoldFund
export async function queryHistoryHoldFund(){
  const url = concatUrl(`/queryHistoryHoldFund`)
  const result = await appRequest(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}
//查询历史交易过的产品资讯
// /queryClientFundInformation
export async function queryClientFundInformation(page = 1, size = 7){
  const url = concatUrl(`/queryClientFundInformation`)
  const result = await appRequest(url, {
    method: 'POST',
    body: JSON.stringify({page, size}),
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

// 认购申购前的校验
export async function checkPermitApply(params) {
  const data = await appRequest(concatUrl(`/user/appoint/checkPermitApply`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
  return data;
}

// 获取我的预约红点
export async function progressFund() {
  const data = await appRequest(concatUrl('/user/progressFund'), {
    method: 'GET'
  })
  return data;
}

// 查询最新消息的轮播手机端
export async function queryCarouselDataMobile(params) {
  const data = await appRequest(concatUrl(`/queryCarouselDataMobile`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
  return data;
}

// 查询公告报告产品资讯-Mobile
export async function queryClientRecentReportMobile(params) {
  const data = await appRequest(concatUrl(`/queryClientRecentReportMobile`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
  return data;
}

// 获取证件是否过期
// export async function checkIdCardExpired() {
//   const result = await appRequest(concatUrl(`/user/checkIdCardExpired`), {
//     method: 'POST'
//   })
//   sessionCache.set('cardExpired', result.data);
//   return result
// }

export async function pendingPushNotices() {
  const result = await appRequest(concatUrl(`/user/pendingPushNotices`), {
    method: 'GET'
  })
  return result
}

export async function confirmPushNotice(params) {
  const result = await appRequest(concatUrl(`/user/confirmPushNotice`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
  return result
}

// 识别图片文字
export async function ocrRecognition({ file, cardSide, cardType }) {
  const body = new FormData()
  body.append('file', file);
  body.append('cardSide', cardSide);
  body.append('cardType', cardType);
  const result = await appRequest(concatUrl(`/user/ocrRecognition`), {
    method: 'POST',
    body,
  })
  return result
}

// 提交证件有效期
export async function updateIdCardValidDate(params) {
  const data = await appRequest(concatUrl(`/user/updateIdCardValidDate`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
  return data;
}
